// @core/api/endpoints/platform/accept_platform_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcceptPlatformInvitationRequest,
  PlatformMemberResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Accept platform invitation
 * Accepts a pending platform invitation. The accepting user becomes a member with the role specified in the invitation.
 */
export async function AcceptPlatformInvitation(
  invitation_id: string,
  data: AcceptPlatformInvitationRequest,
  options?: RequestOptions
): Promise<PlatformMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/invitations/:invitation_id/accept`;
  requestPath = requestPath.replace(':invitation_id', encodeURIComponent(invitation_id));
  const requestOptions = options;
  return client.post<PlatformMemberResponse>(requestPath, data, requestOptions);
}
